import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={9} height={15} fill="none" xmlns="http://www.w3.org/2000/svg"><path clipRule="evenodd" d="M5.713 7.16L.3 1.745A1.023 1.023 0 111.746.3l6.136 6.136c.4.4.4 1.047 0 1.446L1.746 14.02A1.023 1.023 0 01.3 12.572L5.713 7.16z" style={{
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }} /></svg>;
}
export default SvgComponent;